import { render, staticRenderFns } from "./DeActiveCard.vue?vue&type=template&id=c185a846"
import script from "./DeActiveCard.vue?vue&type=script&lang=js"
export * from "./DeActiveCard.vue?vue&type=script&lang=js"
import style0 from "./DeActiveCard.vue?vue&type=style&index=0&id=c185a846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports